import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import Radio from "@mui/material/Radio";
import { Field } from "react-final-form";

interface OptionProps {
  input: {
    value: any;
    [key: string]: any;
  };
  meta: any;
  label?: string;
  [key: string]: any;
}

const Option = (props: OptionProps) => {
  const {
    input: { value, ...restInput },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    meta,
    label,
    ...rest
  } = props;

  return (
    <FormControlLabel
      control={<Radio value={String(value)} />}
      label={label}
      {...restInput}
      {...rest}
    />
  );
};

interface RadioOption {
  value: string | number;
  label: string;
}

interface RadioGroupProps {
  label?: string;
  helperText?: string;
  options?: RadioOption[];
  name: string;
  row?: boolean;
}

export function RadioGroup({
  label,
  helperText,
  options = [],
  name,
  row,
}: RadioGroupProps) {
  return (
    <FormControl component="fieldset">
      {label && <FormLabel component="legend">{label}</FormLabel>}
      <FormGroup row={row}>
        {options.map((option) => (
          <Field
            name={name}
            type="radio"
            value={option.value}
            label={option.label}
            component={Option}
            key={option.value}
          />
        ))}
      </FormGroup>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}
